import { render, staticRenderFns } from "./StageSelectorComponent.vue?vue&type=template&id=77f99522&scoped=true"
import script from "./StageSelectorComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StageSelectorComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StageSelectorComponent.vue?vue&type=style&index=0&id=77f99522&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f99522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f99522')) {
      api.createRecord('77f99522', component.options)
    } else {
      api.reload('77f99522', component.options)
    }
    module.hot.accept("./StageSelectorComponent.vue?vue&type=template&id=77f99522&scoped=true", function () {
      api.rerender('77f99522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StageSelector/StageSelectorComponent.vue"
export default component.exports